"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = exports.PageHeaderSeparator = exports.PAGE_HEADER_TITLE_VIEW = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ControlSeparator_1 = require("../controls/ControlSeparator");
const helpers_1 = require("../Grid/cellRenderers/helpers");
const helpers_2 = require("../helpers");
const Icon_1 = require("../Icon");
const SignPost_1 = require("../SignPost");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const Tooltip_1 = require("../Tooltip");
const View_1 = require("../View");
const BackSvg_1 = require("./icons/BackSvg");
const helpers_3 = require("./helpers");
var PAGE_HEADER_TITLE_VIEW;
(function (PAGE_HEADER_TITLE_VIEW) {
    PAGE_HEADER_TITLE_VIEW["row"] = "row";
    PAGE_HEADER_TITLE_VIEW["column"] = "column";
})(PAGE_HEADER_TITLE_VIEW = exports.PAGE_HEADER_TITLE_VIEW || (exports.PAGE_HEADER_TITLE_VIEW = {}));
const BackIcon = (0, styled_components_1.default)(BackSvg_1.BackSvg) `
    color: ${({ isDisabled, theme }) => isDisabled ? theme.colorControlIconDisabled : theme.colorControlIcon};
    width: 100%;
    height: 100%;
`;
function PageHeaderSeparator() {
    return react_1.default.createElement(ControlSeparator_1.ControlSeparator, { size: ControlSeparator_1.SEPARATOR_SIZE.xl });
}
exports.PageHeaderSeparator = PageHeaderSeparator;
const Title = (0, styled_components_1.default)(Text_1.Text) `
    flex-shrink: 0;
`;
const TextWithTooltip = (_a) => {
    var { text } = _a, rest = __rest(_a, ["text"]);
    const ref = (0, react_1.useRef)(null);
    return (0, Tooltip_1.useTooltip)({
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, text),
        render: (tooltipProps) => {
            return (react_1.default.createElement(Text_1.Text, Object.assign({}, tooltipProps, { "data-selector-id": rest['data-selector-id'], size: Text_1.TEXT_SIZE.xl, view: Text_1.TEXT_VIEW.light, truncate: true, onMouseEnter: (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave, ref: ref }), text));
        }
    });
};
exports.PageHeader = (0, helpers_2.createUIElement)('PageHeader', (_a, ref) => {
    var { className, subtitle, title, info, secondaryText, hasBack = true, disabledBack = false, onBackClick, content, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "subtitle", "title", "info", "secondaryText", "hasBack", "disabledBack", "onBackClick", "content", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const doubleTitle = !!subtitle;
    const dataSelectorId = rest['data-selector-id'] || 'page-header';
    return (react_1.default.createElement(StackView_1.StackView, Object.assign({}, rest, { testId: dataSelectorId, className: `vm-PageHeader ${className}`, direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, indentVertical: View_1.INDENT.s, gap: StackView_1.STACK_GAP.m, size: { height: helpers_2.SIZE_XXL }, distribution: StackView_1.STACK_DISTRIBUTION.lastFill, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        hasBack && (react_1.default.createElement(helpers_3.BackControl, { "data-selector-id": "exitbutton", src: react_1.default.createElement(BackIcon, { isDisabled: disabledBack }), size: Icon_1.ICON_SIZES.xl, onClick: () => {
                if (!disabledBack) {
                    onBackClick === null || onBackClick === void 0 ? void 0 : onBackClick();
                }
            }, isDisabled: disabledBack })),
        hasBack && react_1.default.createElement(PageHeaderSeparator, null),
        react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.s, distribution: StackView_1.STACK_DISTRIBUTION.start, spaceFill: View_1.SPACE_FILL.all },
            react_1.default.createElement(StackView_1.StackView, { direction: doubleTitle ? StackView_1.STACK_DIRECTION.column : StackView_1.STACK_DIRECTION.row, gap: doubleTitle ? StackView_1.STACK_GAP.xs : StackView_1.STACK_GAP.s, spaceFill: View_1.SPACE_FILL.all },
                react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.s, spaceFill: View_1.SPACE_FILL.all },
                    react_1.default.createElement(Title, { size: Text_1.TEXT_SIZE.xl, truncate: true }, title),
                    secondaryText && (react_1.default.createElement(TextWithTooltip, { text: secondaryText, "data-selector-id": `${dataSelectorId}-secondary-text` })),
                    info && doubleTitle && react_1.default.createElement(SignPost_1.SignPost, { text: info })),
                subtitle),
            info && !doubleTitle && (react_1.default.createElement(SignPost_1.SignPost, { text: info, positions: [
                    SignPost_1.SIGN_POST_POSITIONS.topRight,
                    SignPost_1.SIGN_POST_POSITIONS.bottomRight
                ] })),
            content && (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.m, spaceLeft: View_1.INDENT.s }, content)))));
});
//# sourceMappingURL=PageHeader.js.map